import { render, staticRenderFns } from "./NoticeFinalDelivery.vue?vue&type=template&id=0f2b50a8&scoped=true&"
import script from "./NoticeFinalDelivery.vue?vue&type=script&lang=js&"
export * from "./NoticeFinalDelivery.vue?vue&type=script&lang=js&"
import style0 from "./NoticeFinalDelivery.vue?vue&type=style&index=0&id=0f2b50a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b50a8",
  null
  
)

export default component.exports